export default __webpack_public_path__ + "static/media/tpt.7069fc77.svg";